

import { createSlice } from '@reduxjs/toolkit';


const initialState = {
	list: [],
	status: "dormant"
}




const controlsSlice = createSlice({
	name: 'controls',
	initialState,
	reducers: {
	
		setControls: (state, action) => {

			// console.log("do we have an action.payload:", action.payload);

			state.list = action.payload;
			state.status = 'dormant';
		},
		  
		setControlsStatus: (state, action) => {
			state.status = action.payload;
		}

	}
});

export const { setControls, setControlsStatus } = controlsSlice.actions;
export default controlsSlice.reducer;
